 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin":"admin","aliBey":"aliBey","HomeNew.vue":"HomeNew.vue","user":"user","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","habit":"habit","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"fa42c46c","chunk-0637e8e6":"e0de8383","chunk-8aedfcda":"92adb07e","chunk-1ae5ab22":"1f399709","chunk-1d7f8798":"eba77f6a","chunk-1e90651e":"9cf00be5","chunk-217be9fa":"4eed72a2","admin":"9e25f13f","aliBey":"e7774e90","chunk-2c155b26":"7108a3f6","chunk-2d216f56":"5478984d","chunk-5d752f00":"ab85eeee","chunk-5330ff72":"abddf781","chunk-4a0de3e8":"b74ac6cf","chunk-c5a69156":"3cc8287d","HomeNew.vue":"b6a4c5b6","chunk-41aa1ba0":"6b9744b0","chunk-1fb712dd":"67eeffca","chunk-125a7473":"3200756d","user":"7791ec82","chunk-502b709f":"c89c9c7a","chunk-b067410a":"3dc4a508","chunk-ef2249dc":"92d13441","chunk-fd7ca6de":"14f3927f","chunk-3245b86e":"ce16f82d","chunk-fda3fe0e":"14cbf717","chunk-32a83cfb":"0edaaaca","chunk-8dabaea2":"260a4bfa","dashboard":"9feaff39","workouts":"ece8d059","chunk-5397765a":"cb163718","habit~nutrition":"f177cb18","nutrition":"2f03b3d3","einmalig":"59d8ae36","habit":"83096d28","chunk-2472f904":"dab8ac2e","chunk-2895f6ef":"3cf926a7","chunk-2d0ae56b":"da7c86ae","chunk-2d0bff72":"d44f2749","chunk-2d0dda10":"fc094788","chunk-2d0ac1cd":"5f1bffde","shop":"c07ff6fb","chunk-2d225092":"6e15e463","chunk-318ece82":"28427ae8","chunk-32c247d5":"3f097969","chunk-32d00dc6":"95bb24b7","chunk-3cc4f14e":"3a89c0df","chunk-40f278fa":"398401e9","chat":"49b952f8","chunk-12a92868":"3926c8c1","chunk-6e83591c":"22ec3898","social":"47562611","deviceManagement":"2b1de708","event":"9d0c2110","chunk-46924c45":"87acbd33","chunk-4f70ea14":"a5c96af8","chunk-4fa54090":"36a1825f","chunk-54575d3e":"bb739089","chunk-613e6a72":"87048c7f","chunk-6cce70f0":"7c9ee5eb","chunk-3a62fc42":"1d63c278","chunk-8015e132":"d4a62b26","chunk-9e578f18":"fb232493","chunk-bb537da2":"ff2a1469","chunk-743118f7":"efdfb015","chunk-c8626c98":"40e2e58b","chunk-d3af2b4c":"09929c58","chunk-d50be17a":"b9f6f00e","chunk-f4c7454a":"66f9cfca","gf":"b862e6f7","chunk-1e335a6f":"ad580e16","chunk-3a09a1fe":"b3bb2eba","chunk-6d6cce90":"80f9ae75","chunk-e9b88d6a":"0d90a286","chunk-505b5877":"c1af32f0","chunk-8bed398c":"bc247c9d","chunk-9826f532":"dcc7231e","chunk-bf57ea24":"d34130aa","chunk-27503f40":"0648ecf6","chunk-d6e7dbea":"1d36eba9","chunk-ee7e04cc":"68afd793","friends":"4724a948","payment":"09903989","redirection":"3acbed28","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-59b2e543":"6cf6c8f0","chunk-2d0c13c4":"7813a997","chunk-2d209639":"94c15c44","chunk-3f7dbe89":"97200c4d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04a70578":1,"chunk-0637e8e6":1,"chunk-8aedfcda":1,"chunk-1ae5ab22":1,"chunk-1d7f8798":1,"chunk-1e90651e":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-2c155b26":1,"chunk-5d752f00":1,"chunk-5330ff72":1,"chunk-4a0de3e8":1,"chunk-c5a69156":1,"HomeNew.vue":1,"chunk-1fb712dd":1,"chunk-125a7473":1,"user":1,"chunk-502b709f":1,"chunk-b067410a":1,"chunk-ef2249dc":1,"chunk-fd7ca6de":1,"chunk-3245b86e":1,"chunk-fda3fe0e":1,"chunk-32a83cfb":1,"chunk-8dabaea2":1,"dashboard":1,"workouts":1,"chunk-5397765a":1,"habit~nutrition":1,"nutrition":1,"einmalig":1,"habit":1,"chunk-2472f904":1,"chunk-2895f6ef":1,"shop":1,"chunk-318ece82":1,"chunk-32c247d5":1,"chunk-32d00dc6":1,"chunk-3cc4f14e":1,"chunk-40f278fa":1,"chat":1,"chunk-12a92868":1,"social":1,"deviceManagement":1,"event":1,"chunk-46924c45":1,"chunk-4f70ea14":1,"chunk-4fa54090":1,"chunk-54575d3e":1,"chunk-613e6a72":1,"chunk-6cce70f0":1,"chunk-3a62fc42":1,"chunk-8015e132":1,"chunk-9e578f18":1,"chunk-bb537da2":1,"chunk-743118f7":1,"chunk-c8626c98":1,"chunk-d3af2b4c":1,"chunk-d50be17a":1,"chunk-f4c7454a":1,"gf":1,"chunk-1e335a6f":1,"chunk-3a09a1fe":1,"chunk-6d6cce90":1,"chunk-e9b88d6a":1,"chunk-505b5877":1,"chunk-8bed398c":1,"chunk-9826f532":1,"chunk-bf57ea24":1,"chunk-27503f40":1,"chunk-ee7e04cc":1,"friends":1,"chunk-3f7dbe89":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin":"admin","aliBey":"aliBey","HomeNew.vue":"HomeNew.vue","user":"user","dashboard":"dashboard","workouts":"workouts","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","habit":"habit","shop":"shop","chat":"chat","social":"social","deviceManagement":"deviceManagement","event":"event","gf":"gf","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chunk-04a70578":"d888e6e3","chunk-0637e8e6":"7e857e5e","chunk-8aedfcda":"4eb0deb2","chunk-1ae5ab22":"920258b6","chunk-1d7f8798":"ce6c6a57","chunk-1e90651e":"f95702ee","chunk-217be9fa":"fd8c3217","admin":"4fd301a5","aliBey":"d5f8cca3","chunk-2c155b26":"78af78a8","chunk-2d216f56":"31d6cfe0","chunk-5d752f00":"26db51fb","chunk-5330ff72":"d9fc8c5f","chunk-4a0de3e8":"60a0be50","chunk-c5a69156":"927289a6","HomeNew.vue":"b15a2f63","chunk-41aa1ba0":"31d6cfe0","chunk-1fb712dd":"66a1c861","chunk-125a7473":"d1c7bc99","user":"826d11df","chunk-502b709f":"58bd2dfb","chunk-b067410a":"b4b6f499","chunk-ef2249dc":"38cdad1c","chunk-fd7ca6de":"42016920","chunk-3245b86e":"5cbcabdd","chunk-fda3fe0e":"dee56bdd","chunk-32a83cfb":"6279cce3","chunk-8dabaea2":"cbec1d95","dashboard":"51c80b32","workouts":"52788b40","chunk-5397765a":"7481dedb","habit~nutrition":"551557c5","nutrition":"3f18c82e","einmalig":"cc9b3599","habit":"346ce143","chunk-2472f904":"2f713dbd","chunk-2895f6ef":"981dbd42","chunk-2d0ae56b":"31d6cfe0","chunk-2d0bff72":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d0ac1cd":"31d6cfe0","shop":"b224513d","chunk-2d225092":"31d6cfe0","chunk-318ece82":"e6d89b1b","chunk-32c247d5":"15e268be","chunk-32d00dc6":"e345f5a8","chunk-3cc4f14e":"c7a4d223","chunk-40f278fa":"9e01e709","chat":"2eb30eff","chunk-12a92868":"bcca7bd3","chunk-6e83591c":"31d6cfe0","social":"d92bd277","deviceManagement":"23584837","event":"d8b22b17","chunk-46924c45":"df27dbbf","chunk-4f70ea14":"e234d813","chunk-4fa54090":"8415f760","chunk-54575d3e":"68be316c","chunk-613e6a72":"3fa4f906","chunk-6cce70f0":"e0cab876","chunk-3a62fc42":"f1945e3c","chunk-8015e132":"c66fd981","chunk-9e578f18":"b925b436","chunk-bb537da2":"0e3c4884","chunk-743118f7":"001b8d23","chunk-c8626c98":"903c5614","chunk-d3af2b4c":"0abb3627","chunk-d50be17a":"5c500477","chunk-f4c7454a":"00b48790","gf":"41cebc21","chunk-1e335a6f":"4191bb20","chunk-3a09a1fe":"92e13e73","chunk-6d6cce90":"2fefa440","chunk-e9b88d6a":"0088b598","chunk-505b5877":"b0d8115f","chunk-8bed398c":"f58ff143","chunk-9826f532":"1e86cea9","chunk-bf57ea24":"c4baeec9","chunk-27503f40":"8cc03213","chunk-d6e7dbea":"31d6cfe0","chunk-ee7e04cc":"014938f2","friends":"f93a87c1","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-59b2e543":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","chunk-2d209639":"31d6cfe0","chunk-3f7dbe89":"9d560f6c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
